import { ArrowDown, Triangle } from "lucide-react";
import { SITE } from "@/lib/site-data";

const HERO_IMG =
  "https://images.unsplash.com/photo-1768223933860-6d62bc5b2ff3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBidWlsZGluZ3xlbnwwfHx8fDE3Nzc2NjMzNDl8MA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  const scrollToContact = () => {
    document.getElementById("contacto")?.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToServices = () => {
    document.getElementById("servicios")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-[100vh] w-full overflow-hidden flex items-end pb-20 pt-32"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Edificación moderna construida por LUXE"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-black/10" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/20 to-transparent" />
        <div className="absolute inset-0 blueprint-grid opacity-15" />
      </div>

      {/* Side measurement marker */}
      <div className="hidden md:flex absolute left-6 top-1/2 -translate-y-1/2 flex-col items-center gap-3 z-10">
        <div className="w-px h-32 bg-gradient-to-b from-transparent via-[#385723] to-transparent" />
        <Triangle className="w-3 h-3 text-[#385723] fill-[#385723]" />
        <Triangle className="w-3 h-3 text-[#385723] fill-[#385723] rotate-180" />
        <div className="w-px h-32 bg-gradient-to-b from-transparent via-[#385723] to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 lg:col-span-9">
            <div className="flex items-center gap-4 mb-8 animate-fade-in-up">
              <span className="block w-12 h-px bg-white" />
              <span className="overline" style={{ color: "#ffffff" }}>
                Ingeniería · Arquitectura · Construcción
              </span>
            </div>

            <h1
              className="heading-xl text-white text-5xl sm:text-7xl lg:text-8xl xl:text-9xl mb-8 animate-fade-in-up"
              style={{ animationDelay: "0.1s" }}
            >
              Construimos
              <br />
              espacios que
              <br />
              <span className="text-[#385723]">trascienden</span>.
            </h1>

            <p
              className="font-body text-lg lg:text-xl text-white/70 max-w-2xl mb-10 leading-relaxed animate-fade-in-up"
              style={{ animationDelay: "0.25s" }}
            >
              En <span className="text-white font-semibold">{SITE.name}</span> materializamos
              proyectos donde la precisión de la ingeniería civil se encuentra con la excelencia
              arquitectónica. Soluciones <span className="text-[#006961]">llave en mano</span> para
              vivienda, comercio e infraestructura industrial.
            </p>

            <div
              className="flex flex-col sm:flex-row gap-4 animate-fade-in-up"
              style={{ animationDelay: "0.4s" }}
            >
              <button
                data-testid="hero-cta-button"
                onClick={scrollToContact}
                className="btn-luxe bg-[#385723] hover:text-white text-white font-heading font-semibold uppercase tracking-widest px-8 py-5 transition-colors duration-300 border border-[#385723] flex items-center justify-center gap-3 group"
              >
                Solicita una Consulta
                <span className="block w-8 h-px bg-white group-hover:w-12 transition-all" />
              </button>
              <button
                data-testid="hero-secondary-cta"
                onClick={scrollToServices}
                className="bg-transparent hover:bg-white/5 text-white font-heading font-semibold uppercase tracking-widest px-8 py-5 transition-colors duration-300 border border-white/30 flex items-center justify-center gap-3"
              >
                Ver Servicios
              </button>
            </div>
          </div>
        </div>

        {/* Bottom indicator */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10">
          {[
            { k: "ZAPOPAN, JAL.", v: "Sede principal" },
            { k: "LLAVE EN MANO", v: "Modelo integral" },
            { k: "ALTA GAMA", v: "Acabados premium" },
            { k: "ISO", v: "Normas internacionales" },
          ].map((item, i) => (
            <div
              key={i}
              className="bg-black/60 backdrop-blur-sm p-5 flex flex-col gap-1"
            >
              <span className="font-heading text-[#385723] text-xs uppercase tracking-[0.2em] font-semibold">
                {item.k}
              </span>
              <span className="font-body text-white/70 text-xs">{item.v}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={scrollToServices}
        aria-label="Bajar"
        className="hidden md:flex absolute right-6 bottom-10 z-10 w-12 h-12 border border-white/20 items-center justify-center text-white/60 hover:text-white hover:border-white animate-bounce"
      >
        <ArrowDown className="w-4 h-4" />
      </button>
    </section>
  );
}
